import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"

export const getTailoredSchedules = api(({ regimeId, search, take, skip, filters }) =>
    query(
        gql`
            query GetTailoredSchedules(
                $regimeId: String!
                $search: String
                $take: Int
                $skip: Int
                $filters: [TailorFilter]
            ) {
                getTailoredSchedules(
                    regimeId: $regimeId
                    search: $search
                    take: $take
                    skip: $skip
                    filters: $filters
                ) {
                    totalCount
                    items {
                        code
                        scheduleId
                        scheduleTitle
                        scheduleVersion
                        changes {
                            id
                            title
                            classification
                            updatedClassification
                            tailoredValues {
                                included
                                minutes
                                skill {
                                    Skilling
                                }
                                frequency {
                                    interval
                                    period
                                    label
                                }
                                unitOfMeasure
                                classification
                                suppressZeroU
                            }
                            originalValues {
                                included
                                minutes
                                skillSet
                                skill {
                                    Skilling
                                }
                                frequency {
                                    interval
                                    period
                                    label
                                }
                                unitOfMeasure
                                classification
                            }
                            originalTaskId
                        }
                        locations
                        assets
                        tailoringReferenceId
                        tailoredAudits {
                            id
                            referenceId
                            type
                            date
                            userId
                            userName
                            payload
                        }
                    }
                }
            }
        `,
        { regimeId, skip, take, search, filters },
        { returns: "getTailoredSchedules" }
    )
)
